/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { ChangeDetectionStrategy, Component, computed, inject, input, Signal } from '@angular/core';
import { targetSelector } from '@app/core/ngrx';
import { getProjectName, getProjectNameShort } from '@app/domain/application';
import { Store } from '@ngrx/store';

@Component({
  selector: 'project-name',
  template: '{{projectName()}}',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectNameComponent {
  private store = inject(Store);
  public short = input<boolean>(false);
  public projectName: Signal<string | undefined> = computed(() => {
    const short = this.short();
    const target = this.store.selectSignal(targetSelector)();
    if (!target) return;
    return short ? getProjectNameShort(target) : getProjectName(target);
  });
}
